document.addEventListener("DOMContentLoaded", function() {
    if(document.querySelector(".top-nav-show")){
        document.querySelector(".top-nav-show").addEventListener("click", function(e) {
                if (window.matchMedia("only screen and (max-width: 999px)").matches) {

                    document.querySelector(".top-nav--t1").classList.toggle("fadeClass");
                    document.querySelector(".top-nav--t1__ul").classList.toggle("slideClass");
                    document.body.classList.toggle("mobileNavActive");
                    this.classList.toggle("active");
                    e.preventDefault();
                }
            });

        document.body.addEventListener("click", function(e) {
            var target = e.target;

            if (target.classList.contains("top-nav__show--t2")) {
                var container = target.nextElementSibling.querySelector(".top-nav--t2__container");
                container.style.display = container.style.display === "none" ? "" : "none";
                target.classList.toggle("active");
                e.preventDefault();
            }
        });
    }
});
